import { useMemo } from 'react';
import APIContext from './api-context'
import {useCookies} from 'react-cookie'
import API from '../../api/api';


export const APIProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [cookies, , removeCookie] = useCookies();

  // ✅ Inject dependencies once
  const api = useMemo(() => {
    return new API(cookies.userinfo?.accessToken, removeCookie);
  }, [cookies.userinfo?.accessToken, removeCookie]);

  return <APIContext.Provider value={{ api }}>{children}</APIContext.Provider>;
};